import { ReactNode } from "react";

type CardProps = {
	title: string;
	description: string;
	isActive?: boolean;
	onClick?: () => void;
	children?: ReactNode;
	className?: string;
};

export function Card({
	title,
	description,
	isActive = false,
	onClick,
	children,
	className = "",
}: CardProps) {
	const classes = [
		"pf-card",
		isActive ? "pf-card--active" : "",
		onClick ? "pf-card--clickable" : "",
		className,
	]
		.filter(Boolean)
		.join(" ");

	const content = (
		<>
			<h3 className="pf-card__title">{title}</h3>
			<p className="pf-card__description">{description}</p>
			{children}
		</>
	);

	if (onClick) {
		return (
			<button
				type="button"
				className={classes}
				onClick={onClick}
				aria-pressed={isActive}
			>
				{content}
			</button>
		);
	}

	return <div className={classes}>{content}</div>;
}
